<template>
  <div v-if="SSOAvailable">
    <!--div-->
    <div v-if="currentRouteName === 'callback' || isAuthenticated" class="layout layout--hasMenu">
      <div>
        <div>
          <RadioTutorial v-if="showTutorial" />
          <div class="no-gutters row">
            <div class="col-12">
              <AppHeader />
            </div>
          </div>
          <div class="row">
            <div class="col-12" />
          </div>

          <div class="d-flex flex-wrap">
            <div
              class="layout__menu menu__wrapper px-0 d-block d-md-none col-md-4 col-lg-4 col-xl-3 col-12"
              :class="{
                'hidden-menu': menuHidden,
                'mobile-hidden': menuMobileHidden
              }"
            >
              <AppMenu />
            </div>
            <div :key="$route.fullPath" class="layout__content px-0 col">
              <div class="layout__slot">
                <div class="" style="max-width: 100%; width: 600px">
                  <div v-if="errorsURL.length > 0" class="alerts p-3" style="margin-top: 0; position: relative">
                    <div v-for="(error, index) in errorsURL" :key="index" class="alert alert-danger">
                      Připojení k {{ error.type }} trvá příliš dlouho.
                      <small>
                        Zkontrolujte přístup k
                        <a :href="error.link" target="_blank">{{ error.type }}</a>
                        a obnovte stránku.
                      </small>
                    </div>
                  </div>
                </div>

                <StoreNotify class="ml-4" :notifications="globalNotification" />

                <slot />
              </div>
              <footer class="layout__footer text-center mx-3 mx-md-5">
                <p>© {{ currentYear }} České Radiokomunikace a.s.</p>
                <p>by Picards</p>
              </footer>
            </div>
          </div>
        </div>
        <div
          v-if="!isProject && !noProjectVisible && !configStore.isNoProjectPageInfoVisible"
          class="atom-loader--project"
        >
          <div class="side-box__overlay" />
          <AppLoader />
          <p class="text-center text-primary loading-text">{{ $t("nastavujeSeProjekt") }}...</p>
        </div>
      </div>
      <div v-if="waitingLoader">
        <OverlayLoader :loader-title="waitingLoader" />
      </div>
      <div v-if="permissionErrorVisible">
        <ErrorModal :opened="true" :centered="true" @close="logout" />
      </div>

      <div v-if="tokenErrorVisible">
        <ErrorTokenModal :opened="true" :centered="true" @close="refresh" />
      </div>
      <div v-if="loginErrorVisible">
        <ErrorLoginModal :opened="true" :errors="['nepodariloSeZiskatToken']" :centered="true" @close="logout" />
      </div>
      <div v-if="noProjectVisible">
        <ErrorLoginModal
          :errors="['nemateZadnyProjekt']"
          opened
          centered
          @close="
            configStore.setNoProjectVisible({
              noProjectVisible: false,
              noProjectVisiblePageInfo: configStore.isNoProjectPageInfoVisible
            })
          "
        />
      </div>
      <div v-if="customersErrorVisible">
        <ErrorCustomersModal :opened="true" :centered="true" @close="logout" />
      </div>
    </div>
  </div>
  <div v-else class="p-3" style="max-width: 100%; width: 600px">
    <div v-if="errorsURL.length > 0" class="alerts" style="margin-top: 0; position: relative">
      <div v-for="(error, index) in errorsURL" :key="index" class="alert alert-danger">
        Připojení k {{ error.type }} trvá příliš dlouho.
        <small>
          Zkontrolujte přístup k
          <a :href="error.link" target="_blank">{{ error.type }}</a>
          a obnovte stránku.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/header.vue"
import Menu from "@/components/menu/menu.vue"
import Tutorial from "@/components/radio/radio-tutorial.vue"
//import axios from "axios";
import Loader from "@/components/loader.vue"
import LoaderWithOverlay from "@/components/loaderWithOverlay.vue"
import ErrorModal from "@/components/confirmations/permissions.vue"
import ErrorCustomersModal from "@/components/confirmations/customers.vue"
import ErrorTokenModal from "@/components/confirmations/token.vue"
import ErrorLoginModal from "@/components/confirmations/error.vue"
import StoreNotify from "@/components/notify/store-notify.vue"
import { useConfigStore } from "@/store/modules/config"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    AppHeader: Header,
    AppMenu: Menu,
    RadioTutorial: Tutorial,
    AppLoader: Loader,
    OverlayLoader: LoaderWithOverlay,
    ErrorModal,
    ErrorCustomersModal,
    ErrorTokenModal,
    ErrorLoginModal,
    StoreNotify
  },
  setup() {
    const configStore = useConfigStore()
    const projectStore = useProjectStore()
    const authStore = useAuthStore()

    return { configStore, projectStore, authStore }
  },
  data() {
    return {}
  },
  computed: {
    menuHidden() {
      return this.$store.getters["menu/ifHideMenu"]
    },
    menuMobileHidden() {
      return this.$store.getters["menu/ifHideMobileMenu"]
    },
    showTutorial() {
      if (this.$router.currentRoute.value.name === "adminMenu") {
        return this.configStore.isAdminTutorialVisible
      } else if (this.$router.currentRoute.value.name === "dashboard") {
        return this.configStore.isTutorialVisible
      }

      return false
    },
    permissionErrorVisible() {
      return this.configStore.isPermissionErrorVisible
    },
    customersErrorVisible() {
      return this.configStore.isCustomersErrorVisible
    },
    noProjectVisible() {
      return this.configStore.isNoProjectVisible
    },
    tokenErrorVisible() {
      return this.configStore.isTokenErrorVisible
    },
    loginErrorVisible() {
      return this.configStore.isLoginErrorVisible
    },
    waitingLoader() {
      return this.$store.getters["modals/waitingLoader"]
    },
    globalNotification() {
      return this.$store.getters["modals/globalNotification"]
    },
    isAuthenticated() {
      return !!this.authStore.user
    },
    isProject() {
      return !!this.projectStore.selectedProject
    },
    errorsURL() {
      return this.configStore.URLerrors
    },
    SSOAvailable() {
      return this.configStore.connectionSSOOk
    },
    currentRouteName() {
      return this.$route.name
    },
    currentYear() {
      return new Date().getFullYear()
    }
  },
  watch: {
    currentRouteName() {
      console.log(this.currentRouteName)
    }
  },
  mounted() {
    /*if(this.isAuthenticated) {
      this.checkUrls();
    }*/
  },
  methods: {
    logout() {
      this.authStore.signOut()
    },
    refresh() {
      this.configStore.isTokenErrorVisible = false
      localStorage.setItem("reloaded", true)
      this.$router.go(0)
      this.$forceUpdate()
    },
    refresh1() {
      //this.$store.commit("auth/setTokenError", false);
      //localStorage.setItem("reloaded", true);
      this.$router.go(0)
      this.$forceUpdate()
    }
  }
}
</script>
